export default __webpack_public_path__ + "static/media/cost.19ebc14f.svg";